<template>

    <form ref="questaopergunta-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12" v-if="mostraConteudo">
                <label for="pergunta">Pergunta</label>
                <br />
                <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos/Audio</em>
                <textarea v-model="model.pergunta" v-htmleditor="{ hascustomtag: tipoRespostaId == 2 }" required></textarea>
            </div>
            <div class="form-group col-md-6">
                <label for="ordem">Ordem</label>
                <input type="text" class="form-control" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAtivo" class="custom-control-input" v-model="model.ehAtivo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>
        
    </form>
    

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questaopergunta-form-edit",
        mixins: [base],
        props: { id: Number, questaoId: Number, tipoRespostaId: Number },
        data: () => ({

            model: {},

            form: "questaopergunta-form-edit",

            resources: {
                edit: 'questaopergunta',
            },
            mostraConteudo: false
        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                model.questaoId = this.questaoId;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {

            new Api(this.resources.edit).get({ questaoPerguntaId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
                })

            setTimeout(() => { this.mostraConteudo = true; }, 1000);
        }
    };
</script>